// extracted by mini-css-extract-plugin
module.exports = {"clickable":"styles_clickable__1XSyR","large":"styles_large__3yePm"};